import { Component } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { pillsForRoles, RolePill } from '../auth/roles';

@Component({
  selector: 'app-role-pills',
  templateUrl: './role-pills.component.html',
  styleUrls: ['./role-pills.component.scss']
})
export class RolePillsComponent {
  constructor(private authService: AuthService) { }

  get pills(): RolePill[] {
    return pillsForRoles(this.authService.getRoles());
  }
}
